import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, CardBlock } from 'reactstrap';
import { Input, DatePicker, Upload, Button, message } from 'antd';
import moment from 'moment';
// import { Table, DatePicker, Modal } from 'antd';
// import Pagination from 'rc-pagination';
import Select from 'react-select';
// import { SERVER_URL } from './../../../../config/host';
import * as actionnewTasks from './../../../../actions/newTasks';
import './index.css';

@connect(
  state => ({
    newTasksState: state.get('newTasks')
  }),
  dispatch => ({
    newTasksAction: bindActionCreators(actionnewTasks, dispatch)
  })
)

export default class newTasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      name: '',
      proline: '',
      ware: '',
      bgTime: '',
      endTime: '',
      type: '',
      display: 'none',
    };
  }
  componentWillMount() {

  }
  // props 改变时调用
  componentWillReceiveProps() {
  }

  setproLine = (value) => {
    this.setState({
      proline: value || '',
    })
  }
  setwareHouse = (value) => {
    this.setState({
      ware: value || '',
    })
  }
  // 设置时间
  setDate = (value) => {
    let bgTime;
    const date = moment().format('YYYY-MM-DD');
    // const date1 = moment().add('days', 15).format('YYYY-MM-DD')
    if (value && value._d) {
      bgTime = moment(value._d).format('YYYY-MM-DD');
    }
    if (bgTime < date) {
      message.info('盘点开始时间不能小于今天')
    } else {
      this.setState({
        bgTime: bgTime || ''
      })
    }
  }
  setDate1 = (value) => {
    const date = moment().format('YYYY-MM-DD');
    // const bgTime = this.state.bgTime;
    // const date1 = moment().add('days', 15).format('YYYY-MM-DD')
    let endTime;
    if (value && value._d) {
      endTime = moment(value._d).format('YYYY-MM-DD');
    }
    if (endTime < date) {
      message.info('盘点结束时间不能小于今天')
    } else {
      // const d = moment(endTime).diff(moment(bgTime), 'days')
      // if (d > 15) {
      //   message.info('盘点结束时间应为开始时间的15天之内')
      // } else {
      this.setState({
        endTime: endTime || ''
      })
      // }
    }
  }
  conType = (value) => {
    this.setState({
      type: (value && value.id) || '',
    })
  }
  typein = field => (e) => {
    this.setState({ [field]: e.target.value });
  }

  preview = async () => {
    const that = this;
    const { newTasksAction } = this.props;
    const fileList = that.state.fileList;
    const reader = new FileReader();
    const job = {
      name: this.state.name,
      report: this.state.type,
      order: '',        // 预约任务
      strDate: this.state.bgTime, // 开始日期
      endDate: this.state.endTime, // 结束日期
      send: false
    }
    reader.readAsDataURL(fileList[0]);
    reader.onload = (e) => {
      const filename = fileList[0].name;
      const upFile = e.target.result;
      const baseStr = upFile.split(',')[1];
      newTasksAction.fetchGetnewTasks({ fileName: filename, baseStr: baseStr, job: job })
        .then((value) => {
          // console.log('上传任务了呀----------', value)
          const count = value.payload.data.data.count;
          that.setState({
            count: count,
            display: 'block'
          })
        })
      that.setState({
        baseStr: baseStr,
        filename: filename
      })
    }
  }
  send = () => {
    const { newTasksAction } = this.props;
    const { name, filename, bgTime, endTime, type, baseStr } = this.state;
    const date = moment().format('YYYY-MM-DD');
    let order = ''
    if (bgTime > date) {
      order = true
    } else {
      order = false
    }
    const job = {
      name: name,
      report: type,
      order: order,
      strDate: bgTime,
      endDate: endTime,
      send: true
    }
    // console.log('yuyuemamamama------------', job)
    // if(name !=='' && type !=='' && job ){
    // }
    if (name !== '' && filename !== '' && type !== '') {
      // console.log('我是派发的结果呀-------------------')
      newTasksAction.fetchGetnewTasks({ fileName: filename, baseStr: baseStr, job: job })
        .then((value) => {
          if (value.payload.data && value.payload.data.success) {
            message.success(value.payload.data.message);
          } else {
            message.info(value.payload.data.message)
          }
        })
    } else {
      message.info('信息填写完整后再派发')
    }
  }
  disabledDate = ({ current }) => current && current < moment().endOf('day');
  render() {
    const { proline, ware, type } = this.state
    const proLine = [{
      pro: '所有产品线'
    }]
    const wareHouse = [{
      ware: '所有仓库'
    }]
    // now 对比昨天库存
    // night 对比当天库存
    const conType = [{
      type: '对比昨天库存(10分钟)',
      id: 'now'
    }, {
      type: '对比当天库存(隔天)',
      id: 'night'
    }]
    const that = this
    const props = {
      beforeUpload: (e) => {
        that.state.fileList.push(e);
        this.preview()
      },
      multiple: 'false',
      showUploadList: false,
    };

    return (
      <Card>
        <CardBlock>
          <div style={{ margin: '18px auto', width: '420px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }}>
              <p style={{ width: '120px' }}>任务名称:</p>
              <div>
                <Input placeholder="请填写(必填))" style={{ width: '300px' }} onChange={this.typein('name')} />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }}>
              <p style={{ width: '120px' }}>产品线：</p>
              <div>
                <Select
                  placeholder="所有产品线"
                  style={{ width: '300px' }}
                  labelKey="pro"
                  valueKey="id"
                  value={proline || ''}
                  options={proLine}
                  onChange={e => this.setproLine(e)}
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }}>
              <p style={{ width: '120px' }}>仓库：</p>
              <div>
                <Select
                  placeholder="所有仓库"
                  style={{ width: '300px' }}
                  labelKey="ware"
                  value={ware || ''}
                  options={wareHouse}
                  onChange={e => this.setwareHouse(e)}
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }}>
              <p style={{ width: '120px' }}>任务开始时间：</p>
              <div>
                <DatePicker
                  placeholder="选填"
                  style={{ width: '300px' }}
                  format="YYYY-MM-DD"
                  disabledDate={this.disabledDate}
                  size="large"
                  onChange={e => this.setDate(e)}
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }}>
              <p style={{ width: '120px' }}>任务结束时间：</p>
              <div>
                <DatePicker
                  format="YYYY-MM-DD"
                  size="large"
                  style={{ width: '300px' }}
                  placeholder="选填"
                  // disabledDate={(current) => { return current < moment() }}
                  onChange={e => this.setDate1(e)}
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }}>
              <div>
                <p style={{ width: '120px', height: '4px' }}>对比类型：</p>
                <span style={{ fontSize: '9px' }}>(报告生成时间)</span>
              </div>
              <div>
                <Select
                  placeholder="请选择(必选)"
                  style={{ width: '300px' }}
                  labelKey="type"
                  valueKey="id"
                  value={type || ''}
                  options={conType}
                  onChange={e => this.conType(e)}
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '15px' }}>
              <p style={{ width: '120px' }}>经销商列表：</p>
              <div>
                <Upload {...props}>
                  <Button>上传任务列表</Button>
                </Upload>
              </div>
              <div style={{ textDecoration: 'underline', margin: '9px 45px', color: '#259B24', fontSize: '12px', fontWeight: 'bold' }}><a href="http://tooup.fun/file/get/152/上传模板.xlsx">下载任务模板</a></div>
            </div>
            <div style={{ display: this.state.display, marginLeft: '120px', marginBottom: '20px' }}>
              ● 派发的经销商家数为：{this.state.count}
            </div>
            <div>
              <button style={{ width: '420px', borderRadius: '8px', border: '1px solid #11A0F8', backgroundColor: '#11A0F8', height: '36px', color: 'white' }} onClick={this.send}>派发任务</button>
            </div>
          </div>
        </CardBlock>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/App/Tasks/newTasks/index.js